module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-08.a25d75c3.jpeg";